import { z } from 'zod';
/**
 * The sidebar tabs that can carry a red count (t1219). A key missing from the
 * response means either "nothing waiting" or "this staff member may not see
 * that tab", and the UI treats both the same: no badge.
 */
export const NAV_COUNT_KEYS = [
    'support',
    'tasks',
    'mail',
    'orders',
    'repairs',
    'rentals',
    'provisioning',
    'stock',
    'stockRequests',
    'machines',
    'workspace',
];
export const navCountsSchema = z.partialRecord(z.enum(NAV_COUNT_KEYS), z.number().int());
//# sourceMappingURL=nav-counts.js.map